import styled, { keyframes } from 'styled-components'

const shimmer = keyframes`
  from {
    left: -100%;
  }
  to {
    left: 100%;
  }
`

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`

export const LinksGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const SectionHeader = styled.div`
  margin-bottom: 12px;
`

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
`

export const SectionDescription = styled.p`
  font-size: 13px;
  color: #6b6b6b;
  line-height: 1.5;
  margin: 0;
`

export const LinksGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const LinkCard = styled.a<{ $isLoading?: boolean }>`
  display: flex;
  align-items: center;
  padding: 8px 10px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  text-decoration: none;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  ${(props) =>
    props.$isLoading &&
    `
    pointer-events: none;
    opacity: 0.6;
  `}

  &:hover {
    background: #f5f5f5;
    border-color: #999999;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }
`

export const ServiceIcon = styled.div<{
  $background: string
  $color: string
  $isLoading?: boolean
}>`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
  background: ${(props) => props.$background};
  color: ${(props) => props.$color};
  position: relative;
  overflow: hidden;

  svg {
    width: 18px;
    height: 18px;
  }

  ${(props) =>
    props.$isLoading &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
      animation: ${shimmer} 1.5s infinite;
    }
  `}
`

export const LinkContent = styled.div`
  flex: 1;
  min-width: 0;
`

export const LinkTitle = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  margin-bottom: 2px;
  display: block;
`

export const LinkDescription = styled.span`
  font-size: 11px;
  color: #6b6b6b;
  line-height: 1.3;
`

export const ExternalArrow = styled.svg`
  width: 16px;
  height: 16px;
  color: #999999;
  flex-shrink: 0;
  margin-left: 12px;
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 24px;
`

export const EmptyIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto 16px;
  color: #999999;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 48px;
    height: 48px;
  }
`

export const EmptyTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #6b6b6b;
  margin-bottom: 8px;
`

export const EmptyDescription = styled.div`
  font-size: 13px;
  color: #999999;
`
